// extracted by mini-css-extract-plugin
export default {"container":"CookiePopup_container__IGOyJ","text":"CookiePopup_text__U0RSf","btn":"CookiePopup_btn__92IZE"};